export default __webpack_public_path__ + "static/media/icon-generate-billet.dbff652a.svg";